import { Injectable } from "@angular/core";
import L from "../leaflet-plugins-loader";
import { INgsiAIS } from "../../ngsild/interfaces/ngsi-ais.interface";
import { INgsiMaritimeTargets } from "../../ngsild/interfaces/ngsi-maritime-targets.interface";
import { INgsiRadarTarget } from "../../ngsild/interfaces/ngsi-radar-target.interface";

@Injectable({
  providedIn: "root",
})
export class TooltipService {
  getOptions(): L.TooltipOptions {
    return {
      permanent: true,
      className: "leaflet-permanent-tooltip",
      direction: "right",
    } as L.TooltipOptions;
  }

  getTooltip(toolTipContent: string, marker?: L.Marker<any>): L.Tooltip {
    let tooltip = marker?.getTooltip();

    if (!tooltip) {
      tooltip = L.tooltip().setContent(toolTipContent);
    }

    return tooltip;
  }

  bindTooltipOnce(
    marker: L.Marker<any>,
    entity: INgsiAIS | INgsiMaritimeTargets | INgsiRadarTarget,
    showPermanentTooltip: boolean,
  ) {
    if (!marker || (marker as any)._tooltipInitialized) {
      return;
    }

    (marker as any)._tooltipInitialized = true;

    const tooltipContainer = document.createElement("div");

    const titleText = entity.name ?? entity.id;

    const titleSpan = document.createElement("span");
    titleSpan.className = "tooltip-title";
    titleSpan.textContent = titleText;
    tooltipContainer.appendChild(titleSpan);

    const cogSpan = document.createElement("span");
    cogSpan.className = "tooltip-item-suffix-orange";
    cogSpan.textContent = entity.cog != null ? `${entity.cog.toFixed(0)}°` : "";
    tooltipContainer.appendChild(cogSpan);

    const sogSpan = document.createElement("span");
    sogSpan.className = "tooltip-item-suffix-blue";
    sogSpan.textContent = `${(entity.sog ?? 0).toFixed(0)} kn`;
    tooltipContainer.appendChild(sogSpan);

    marker.bindTooltip(tooltipContainer, {
      permanent: true,
      direction: "right",
      className: "leaflet-permanent-tooltip",
    });

    marker.getTooltip()?.setOpacity(showPermanentTooltip ? 1 : 0);

    (marker as any)._tooltipElements = {
      titleSpan,
      cogSpan,
      sogSpan,
    };
  }

  updateTooltipContent(
    entity: INgsiAIS | INgsiMaritimeTargets | INgsiRadarTarget,
    marker: L.Marker<any>,
  ) {
    if (!marker) return;

    const elems = (marker as any)._tooltipElements as {
      titleSpan: HTMLSpanElement;
      cogSpan: HTMLSpanElement;
      sogSpan: HTMLSpanElement;
    };

    if (!elems) return;

    const newTitle = entity.name ?? entity.id;
    if (elems.titleSpan.textContent !== newTitle) {
      elems.titleSpan.textContent = newTitle;
    }

    const newCog = entity.cog != null ? `${entity.cog.toFixed(0)}°` : "";
    if (elems.cogSpan.textContent !== newCog) {
      elems.cogSpan.textContent = newCog;
    }

    const newSog = `${(entity.sog ?? 0).toFixed(0)} kn`;
    if (elems.sogSpan.textContent !== newSog) {
      elems.sogSpan.textContent = newSog;
    }
  }
}
